import { render, staticRenderFns } from "./ConsentManager.vue?vue&type=template&id=0786ec18&scoped=true"
import script from "./ConsentManager.vue?vue&type=script&lang=js"
export * from "./ConsentManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0786ec18",
  null
  
)

export default component.exports